import React from 'react';
import { Link } from 'react-router-dom';

import MToolbarMobileMenu from './MToolbarMobileMenu/MToolbarMobileMenu';

import { IMenu } from './MToolbar.model';
import classes from './MToolbar.module.scss';
import { condClass } from 'app/utils/general';
import MIcon from '../MIcon/MIcon';

interface Props {
  menu: IMenu[];
  logo?: string;
  className?: string;
  actions?: JSX.Element;
  mobileMenu: boolean;
  platform: 'mobile' | 'desktop';
  onLogoClick: () => void;
  onMobileMenuClick: () => void;
  onMobileMenuExit: () => void;
}

const MToolbarView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <React.Fragment>
      {props.mobileMenu ? (
        <MToolbarMobileMenu className={classes['mobileMenu']} onExit={props.onMobileMenuExit} menu={props.menu}></MToolbarMobileMenu>
      ) : null}
      <header className={condClass({ [classes['container']]: true, [String(props.className)]: !!props.className })}>
        <div className={classes['content']}>
          <img className={classes['logo']} src={props.logo} onClick={props.onLogoClick} />
          <div className={classes['wideSpace']}>
            {props.platform === 'desktop' ? (
              <menu className={classes['menu']}>
                <ul className={classes['menuList']}>
                  {props.menu.map((menu: IMenu, index: number) => {
                    return (
                      <li key={index}>
                        <Link to={menu.to} className={classes['menuItem']}>
                          {menu.label}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </menu>
            ) : null}
          </div>
          {props.children}
          {props.platform === 'mobile' ? (
            <button type="button" onClick={props.onMobileMenuClick}>
              <MIcon name="cisHamburgerMenu" className={classes['mobileIcon']}></MIcon>
            </button>
          ) : null}
        </div>
      </header>
    </React.Fragment>
  );
};

MToolbarView.displayName = 'MToolbarView';
MToolbarView.defaultProps = {};

export default MToolbarView;
